import { Sun, Moon } from "lucide-react";
import { useUIStore } from "@/stores/ui.store";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function ThemeSwitcher({ collapsed }: { collapsed?: boolean }) {
  const theme = useUIStore((s) => s.theme);
  const toggleTheme = useUIStore((s) => s.toggleTheme);

  const iconClasses = "h-[1.2rem] w-[1.2rem] transition-all";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={toggleTheme}
          className={cn(
            "flex items-center justify-center rounded-md hover:bg-primary/10 hover:text-primary transition-colors text-secondary",
            collapsed ? "h-9 w-9" : "grow h-9 px-3 gap-2",
          )}
          aria-label="Toggle theme"
        >
          {theme === "dark" ? (
            <>
              <Sun className={cn(iconClasses, "text-amber-400")} />
              {!collapsed && (
                <span className="text-[14px] font-medium grow text-left">Light Mode</span>
              )}
            </>
          ) : (
            <>
              <Moon className={cn(iconClasses, "text-secondary")} />
              {!collapsed && (
                <span className="text-[14px] font-medium grow text-left">Dark Mode</span>
              )}
            </>
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent side="right">
        <p>{theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}</p>
      </TooltipContent>
    </Tooltip>
  );
}
